/* ui/tournament/TournamentPage.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	append,
	attr,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "svelte/internal";

import { tournamentModeStore, game } from "../store";
import StartButton from "./StartButton.svelte";
import ResetButton from "./ResetButton.svelte";
import Configuration from "./Configuration.svelte";
import TournamentResults from "./TournamentResults.svelte";

function add_css() {
	var style = element("style");
	style.id = "svelte-1m132t5-style";
	style.textContent = ".container.svelte-1m132t5{display:grid;grid-gap:10px;place-items:center}";
	append(document.head, style);
}

function create_fragment(ctx) {
	let div3;
	let p;
	let t1;
	let div0;
	let startbutton;
	let t2;
	let resetbutton;
	let t3;
	let div1;
	let configuration;
	let t4;
	let div2;
	let tournamentresults;
	let current;
	startbutton = new StartButton({});
	resetbutton = new ResetButton({});
	configuration = new Configuration({});
	tournamentresults = new TournamentResults({});

	return {
		c() {
			div3 = element("div");
			p = element("p");
			p.textContent = "Run multiple matches between two AI to see which is better! Note: may slow down your browser if one of the AIs is slow.";
			t1 = space();
			div0 = element("div");
			create_component(startbutton.$$.fragment);
			t2 = space();
			create_component(resetbutton.$$.fragment);
			t3 = space();
			div1 = element("div");
			create_component(configuration.$$.fragment);
			t4 = space();
			div2 = element("div");
			create_component(tournamentresults.$$.fragment);
			attr(div0, "class", "buttons svelte-1m132t5");
			attr(div1, "class", "configuration svelte-1m132t5");
			attr(div2, "class", "results svelte-1m132t5");
			attr(div3, "class", "container svelte-1m132t5");
		},
		m(target, anchor) {
			insert(target, div3, anchor);
			append(div3, p);
			append(div3, t1);
			append(div3, div0);
			mount_component(startbutton, div0, null);
			append(div0, t2);
			mount_component(resetbutton, div0, null);
			append(div3, t3);
			append(div3, div1);
			mount_component(configuration, div1, null);
			append(div3, t4);
			append(div3, div2);
			mount_component(tournamentresults, div2, null);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(startbutton.$$.fragment, local);
			transition_in(resetbutton.$$.fragment, local);
			transition_in(configuration.$$.fragment, local);
			transition_in(tournamentresults.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(startbutton.$$.fragment, local);
			transition_out(resetbutton.$$.fragment, local);
			transition_out(configuration.$$.fragment, local);
			transition_out(tournamentresults.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div3);
			destroy_component(startbutton);
			destroy_component(resetbutton);
			destroy_component(configuration);
			destroy_component(tournamentresults);
		}
	};
}

class TournamentPage extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1m132t5-style")) add_css();
		init(this, options, null, create_fragment, safe_not_equal, {});
	}
}

export default TournamentPage;